module.exports = __webpack_public_path__ + "img/Lanesborough_Icon.02638a90.png";